module.exports = __webpack_public_path__ + "static/installations-thumbnail-d31a8c063ac0d93d1788d96439e92765.jpg";